const EMBED_SOURCE = 'embed'

export { EMBED_SOURCE }
